import React, { useEffect, useState } from 'react'
import InputField from '../../../components/ui/Input'
import Select from 'react-select';

const ReferalCreateModal = ({ onCancel, onSubmit, title, inputData, handleONChange, preference, setCate, cate, errors: propErrors, setErrors }) => {
  const [validationErrors, setValidationErrors] = useState({});

  const modifiedData = preference.map((e) => ({
    value: e?._id,
    label: e?.name
  }));

  // Modified onChange handler to clear errors for the changed field
  const handleInputChange = (e) => {
    const { name } = e.target;
    
    // Clear validation error for this field
    if (validationErrors[name]) {
      const newValidationErrors = { ...validationErrors };
      delete newValidationErrors[name];
      setValidationErrors(newValidationErrors);
    }
    
    // Clear prop errors if setErrors function is provided
    if (propErrors && propErrors[name] && setErrors) {
      const newErrors = { ...propErrors };
      delete newErrors[name];
      setErrors(newErrors);
    }
    
    // Call the original onChange handler
    handleONChange(e);
  };

  const handleReactMultiSelect = (selectedData) => {
    // Clear category/preference related errors
    if (validationErrors.preference) {
      const newValidationErrors = { ...validationErrors };
      delete newValidationErrors.preference;
      setValidationErrors(newValidationErrors);
    }
    
    if (propErrors && propErrors.preference && setErrors) {
      const newErrors = { ...propErrors };
      delete newErrors.preference;
      setErrors(newErrors);
    }
    
    setCate(selectedData);
  };

  // Validate discount value whenever it changes
  useEffect(() => {
    if (inputData?.discount) {
      const discountValue = parseFloat(inputData.discount);
      const newErrors = { ...validationErrors };
      
      if (isNaN(discountValue)) {
        newErrors.discount = "Discount must be a valid number";
      } else if (discountValue <= 0) {
        newErrors.discount = "Discount must be greater than 0";
      } else if (discountValue > 100) {
        newErrors.discount = "Discount can't be more than 100%";
      } else {
        delete newErrors.discount;
      }
      
      setValidationErrors(newErrors);
    }
  }, [inputData?.discount]);

  // Custom handler that combines local validation with passed validation
  const handleSubmit = (e) => {
    // Check all validations here
    const newErrors = { ...validationErrors };
    
    if (!inputData?.referralName || inputData.referralName.trim() === '') {
      newErrors.referralName = "Referral name is required";
    }
    
    if (!inputData?.discount || inputData.discount === '') {
      newErrors.discount = "Discount value is required";
    }
    
    if (!cate || cate.length === 0) {
      newErrors.preference = "At least one category must be selected";
    }
    
    if (Object.keys(newErrors).length > 0) {
      setValidationErrors(newErrors);
      return;
    }
    
    onSubmit(e);
  };

  // Merge errors from props and local validation
  const errors = { ...propErrors, ...validationErrors };

  return (
    <div>
      <div className="fixed inset-0 bg-black/50 bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
        <div className="bg-white rounded-lg shadow-lg w-11/12 lg:max-w-3xl">
          <div className="border-b w-full">
            <div className="flex justify-between items-center pb-2 p-6">
              <h3 className="text-lg font-semibold">{title}</h3>
              <button
                className="text-gray-500 text-2xl w-10 h-10 bg-gray-100 rounded-full hover:text-gray-800"
                onClick={onCancel}
              >
                &times;
              </button>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 items-center p-6">
            <InputField 
              label="Name" 
              name="referralName" 
              value={inputData?.referralName || ''} 
              onChange={handleInputChange} 
              maxlength={20}
            />
            {errors?.referralName && (
              <p className="text-red-500 text-sm mt-1">{errors.referralName}</p>
            )}

            <InputField 
              label="Discount (%)" 
              name="discount" 
              value={inputData?.discount || ''} 
              onChange={handleInputChange} 
              type="number" 
            />
            {errors?.discount && (
              <p className="text-red-500 text-sm mt-[-30px]">{errors.discount}</p>
            )}

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">Course Category</label>
              <Select 
                options={modifiedData} 
                isMulti 
                onChange={handleReactMultiSelect} 
                value={cate}
                placeholder="Select categories..."
                className="mt-1"
              />
              {errors?.preference && (
                <p className="text-red-500 text-sm mt-1">{errors.preference}</p>
              )}
            </div>
          </div>

          <div className="flex justify-center space-x-3 border-t p-4">
            {/* <button
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-100"
              onClick={onCancel}
            >
              Cancel
            </button> */}
            <button
              className="px-6 py-3 bg-purple-600 text-white rounded hover:bg-purple-700 w-44 font-[500] text-[16px] font-[Inter]"
              onClick={(e)=>(handleSubmit(e))}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReferalCreateModal